// Module
var code = "<md-input-container> <md-select ng-model=\"$ctrl.currentLang\" ng-change=\"$ctrl.changeLang()\" md-no-underline> <md-option ng-repeat=\"lang in $ctrl.langList track by $index\" ng-value=\"lang\" ng-class=\"{ 'md-focused': $ctrl.currentLang === lang }\">{{ $ctrl.langLabel[lang] }}</md-option> </md-select> </md-input-container> ";
// Exports
module.exports = code;